exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Business-component{height:100vh}.Business-component .nav{width:100%;height:44px;text-align:center;font-size:16px;line-height:44px;background-color:#d3d3d3}.Business-component .item{border-bottom:1px solid #ddd;background:#fff;padding:5px 15px;height:60px}.Business-component .item .avatar{float:left;width:50px;height:50px}.Business-component .item .avatar img{width:100%;height:100%}.Business-component .item .title{width:calc(100% - 60px);float:right;font-size:12px;line-height:24px;color:#999;max-height:45px;overflow:hidden}.Business-component .item .title .name{font-size:14px;color:#333}.Business-component .footer{height:60px;background:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/Business.scss
// module id = 625
// module chunks = 0